var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1c-1.105 0-2 .895-2 2 0 .738.402 1.371 1 1.719V7h-5c-2.75 0-5 2.25-5 5v2H2v8h3v5h22v-5h3v-8h-3v-2c0-2.75-2.25-5-5-5h-5V4.719c.598-.348 1-.98 1-1.719 0-1.105-.895-2-2-2zm-6 8h12c1.668 0 3 1.332 3 3v13h-2v-5H9v5H7V12c0-1.668 1.332-3 3-3zm2 4a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4zm8 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4zM4 16h1v4H4v-4zm23 0h1v4h-1v-4zm-16 6h2v3h-2v-3zm4 0h2v3h-2v-3zm4 0h2v3h-2v-3z",
    fill: "#150349"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSolid);
export default __webpack_public_path__ + "static/media/robot-solid.0315e8223515adeff521d9efb6405700.svg";
export { ForwardRef as ReactComponent };